import { render, staticRenderFns } from "./firendBlack.vue?vue&type=template&id=451f6253&scoped=true"
import script from "./firendBlack.vue?vue&type=script&lang=js"
export * from "./firendBlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f6253",
  null
  
)

export default component.exports